import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Checkbox from './formElements/Checkbox'
import HorizontalSingleAxis from './formElements/HorizontalSingleAxis'
import { getPrintPreview } from './utils'
//import '../../assets/css/multiChoice.css'

@observer
export default class MultiChoice extends Component {
    constructor(props) {
        super(props)
        this.width = 161 // px
		this.marginRight = 14 // px
    }

	handleChange(option, e) {
		const numKeysTrue = (data) => {
            var ct = 0
            for(let k in data){
                if(data[k]){
                    ct += 1
                }
            }
            return ct
        }
		const {question, store} = this.props
		store.addFormResponse(question, e.target.checked, option)
    }

	render() {
		var content
        const {question, store} = this.props
        const { displayCols } = question.settings.frontend
		const set = question.optionSet
		const options = set.options
		const dspHorizontal = question.settings.frontend.hasOwnProperty("alignment") && question.settings.frontend.alignment === "H" && !store.displayForMobile() ? true : false
        if(!dspHorizontal){
			content = options.filter(o => o.willDisplay !== false).map((option) => {
                if (option.isHidden) {
                    return null
                } else {
                    return  <Checkbox
                                key={option.id}
                                option={option}
                                question={question}
                                handleChange={this.handleChange}
                                other={option.hasOwnProperty("hasOptionOther") ? option.hasOptionOther : null}
                                store={store}
                                mode="normal"
                            />
                }
            });
            content = (
                <div
                    style={{ columns: (displayCols > 1) ? displayCols : 'auto'} }
                    className={`single-multiple-choice-vertical-con ${(displayCols > 1) ? 'single-multiple-choice-vertical-con--columns' : ''}`}
                >
                    {content}
                </div>
            )
		} else {
            content = (
                <HorizontalSingleAxis
                    width={this.width}
                    marginRight={this.marginRight}
                    store={store}
                    question={question}
                    handleChange={this.handleChange}
                    type="checkbox"
                />
            )
		}
		return (
			<div>
                {getPrintPreview(question, store)}
				{content}
			</div>
		)
	}
}
